
import { regionTypesEnum } from '@/views/checkout/constant';
import { getAccountInfo } from '@/apis/signing';

const state = {
  account: {
    __isLoggedIn: false,
    age: '',
    firstName: '',
    lastName: '',
    email: '',
    password: '',
  },
  _rawAccount: undefined,
  _shouldCompleteAccountName: false,
  _completedAccountName: undefined,
  agreements: {
    regionTypes: regionTypesEnum.NOLIMITED_REGIONS,
    terms: false,
    collection: false,
    marketingReview: false
  },
  zuoraInfo: {
    field_accountId: '',
    field_authorizationAmount: ''
  },
  lookupInfo: {
    callBackHost: undefined,
    accountId: undefined,
    email: undefined
  },
}

const getters = {
  account: (state) => state.account,
  rawAccount: ({ _rawAccount }, getters) => {
    return _rawAccount && _rawAccount.email === getters.account.email ? _rawAccount : undefined
  },
  shouldCompleteAccountName: (state, getters) => state._shouldCompleteAccountName && getters.withOutCcAccount,
  completedAccountName: (state, getters) => {
    const { _completedAccountName: data } = state
    return getters.shouldCompleteAccountName && data && data.email === getters.account.email ? data : undefined
  },
  agreements: (state) => state.agreements,
  zuoraInfo: (state) => state.zuoraInfo,
  lookupInfo: (state) => state.lookupInfo,
}

const mutations = {
  setLookupInfo(state, lookupInfo) {
    state.lookupInfo = lookupInfo;
  },
  setAccount(state, data) {
    if (data === false) return Object.keys(state.account).forEach(key => state.account[key] = '');
    return state.account = Object.assign({}, state.account, data);
  },
  setRawAccount(state, data) {
    state._rawAccount = data ? { ...data, email: data.email || state.account.email } : undefined
  },
  setShouldCompleteAccountName(state, data) {
    state._shouldCompleteAccountName = data
  },
  setCompletedAccountName(state, data) {
    state._completedAccountName = data ? { ...data, email: data.email || state.account.email } : undefined
  },
  setAgreements(state, agreements) {
    return state.agreements = Object.assign({}, state.agreements, agreements);
  },
  setZuoraInfo(state, data) {
    return state.zuoraInfo = Object.assign({}, state.zuoraInfo, data);
  }
}

const actions = {
  async initAccountInfo({ commit }) {
    if (window.$context.is.loggedIn) {
      const { result } = await getAccountInfo();
      commit('setAccount', result);
      commit('setRawAccount', { firstName: result.firstName, lastName: result.lastName })
      commit('setAgreements', { marketingReview: !!result?.gdprOpt });
    } else {
      commit('setRawAccount', null)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
}
